// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.featuresbeta.RentalManagerUserFeaturesBetaWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserFeaturesBetaWebApiHandler_details,
  RentalManagerUserFeaturesBetaWebApiHandler_details_Path,
  RentalManagerUserFeaturesBetaWebApiHandler_enroll,
  RentalManagerUserFeaturesBetaWebApiHandler_unenroll,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { FeaturesBetaDetailsResponseDto } from '@zg-rentals/ts-rental-manager-api-client';

interface DetailsParams {
  featureName: string;
}

export type RentalManagerUserFeaturesBetaWebApiHandler_details_Options = UseQueryOptions<
  FeaturesBetaDetailsResponseDto,
  unknown,
  FeaturesBetaDetailsResponseDto,
  readonly [string, DetailsParams]
>;

const RentalManagerUserFeaturesBetaWebApiHandler_details_GetKey = (getParams: DetailsParams) =>
  [RentalManagerUserFeaturesBetaWebApiHandler_details_Path, getParams] as const;

export const RentalManagerUserFeaturesBetaWebApiHandler_details_queryOptions = (
  getParams: DetailsParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserFeaturesBetaWebApiHandler_details_GetKey(getParams),
    queryFn: () => RentalManagerUserFeaturesBetaWebApiHandler_details(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get the current user's beta status and opt-in prompt for a beta feature
 */
export const useRentalManagerUserFeaturesBetaWebApiHandler_details = (
  getParams: DetailsParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserFeaturesBetaWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserFeaturesBetaWebApiHandler_details_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserFeaturesBetaWebApiHandler_details.getKey =
  RentalManagerUserFeaturesBetaWebApiHandler_details_GetKey;

export type RentalManagerUserFeaturesBetaWebApiHandler_enroll_Options = UseMutationOptions<void, unknown, void>;

/**
 * Accept the features beta terms and enroll the current user in the features beta
 */
export const useRentalManagerUserFeaturesBetaWebApiHandler_enroll = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFeaturesBetaWebApiHandler_enroll_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserFeaturesBetaWebApiHandler_enroll(httpClient),
  });
};

export type RentalManagerUserFeaturesBetaWebApiHandler_unenroll_Options = UseMutationOptions<void, unknown, void>;

/**
 * Remove the current user from the features beta
 */
export const useRentalManagerUserFeaturesBetaWebApiHandler_unenroll = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserFeaturesBetaWebApiHandler_unenroll_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => RentalManagerUserFeaturesBetaWebApiHandler_unenroll(httpClient),
  });
};
